import React, { useState } from "react";
import axios from "axios";
import "./AadhaarInput.css";

const AadhaarInput = ({ onNext }) => {
  const [aadhaar, setAadhaar] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);

  const isValid = /^\d{12}$/.test(aadhaar);

  const sendOtp = async () => {
    if (!isValid || !consent) return;
    setLoading(true);

    try {
      console.log("SEND OTP:", aadhaar);

      // 🔥 React now calls YOUR PHP BACKEND (NO CORS PROBLEM)
      const API_URL = "https://fundswalla.in/loan_backend/sendAadhaarOtp.php";

      const payload = { aadhaar_number: aadhaar };
      console.log("PAYLOAD:", payload);

      const res = await axios.post(API_URL, payload, {
        headers: { "Content-Type": "application/json" },
      });

      console.log("OTP RESPONSE:", res.data);

      // ScoreMe response usually inside raw
      const raw = res.data.raw || {};
      const { responseMessage, responseCode } = raw;

      // Invalid Aadhaar Handling
      if (
        responseMessage === "Aadhar does not exist" ||
        responseCode === "EAE168" ||
        (responseMessage && responseMessage.toLowerCase().includes("does not exist"))
      ) {
        alert("Invalid Aadhaar number. Please enter a valid 12-digit Aadhaar.");
        setLoading(false);
        return;
      }

      // Save Reference IDs
      localStorage.setItem("aadhaarNumber", aadhaar);
      localStorage.setItem("aadhaarReferenceId",res.data.referenceId);

      onNext();
    } catch (err) {
      console.error("SEND OTP ERROR:", err?.response?.data || err.message);

      const raw = err?.response?.data?.raw;
      if (
        raw?.responseMessage === "Aadhar does not exist" ||
        raw?.responseCode === "EAE168"
      ) {
        alert("Invalid Aadhaar number.");
      } else {
        alert("OTP failed: " + (err?.response?.data?.message || err.message));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="aadhaar-page-wrapper">
      <div className="aadhaar-card">
        <div className="aadhaar-icon">🔐</div>

        <h3 className="aadhaar-title">Secure Aadhaar Verification</h3>

        <p className="aadhaar-subtitle">
          Enter your 12-digit Aadhaar number to proceed.
        </p>

        <input
          maxLength={12}
          value={aadhaar}
          onChange={(e) => /^\d*$/.test(e.target.value) && setAadhaar(e.target.value)}
          placeholder="XXXX XXXX XXXX"
          className={`aadhaar-input ${isValid ? "valid" : ""}`}
        />

        <div className="form-check consent-box">
          <input
            type="checkbox"
            checked={consent}
            onChange={() => setConsent(!consent)}
          />
          <label>
            I authorize <b>Aadhaar verification</b> and receipt of <b>digital communications</b>.
          </label>
        </div>

        <button
          className={`aadhaar-btn ${isValid && consent ? "active" : "disabled"}`}
          disabled={!isValid || !consent || loading}
          onClick={sendOtp}
        >
          {loading ? "Sending OTP..." : "Get OTP"}
        </button>

        <p className="aadhaar-note">Your information is encrypted and secured.</p>
      </div>
    </div>
  );
};

export default AadhaarInput;
